export const COMPLETED = 'completed';